import { Ability } from '@casl/ability';
import * as types from './mutation-types';

export const ability = new Ability();

/**
 * Go through each roles of a user and set permissions
 * @param user
 */
const updateAbilities = (user) => {
  const { roles } = user;
  const allPermissions = [];
  roles.forEach((role) => {
    const { permissions } = role;
    const abilities = permissions.map(p => ({
      actions: p.name,
      subject: p.section,
    }));
    allPermissions.push(...abilities);
  });

  ability.update(allPermissions);
};

/**
 * Sets permissions
 * @param store
 * @returns {*|(() => void)|Promise<PushSubscription>}
 */
export const abilityPlugin = (store) => {
  const user = store.getters.authUser;

  // Page load will set permissions from obtained user
  if (user) {
    updateAbilities(user);
  }

  return store.subscribe((mutation) => {
    switch (mutation.type) {
      // On fetching a user, set permissions
      case types.FETCH_USER_SUCCESS:
        updateAbilities(mutation.payload.user);
        break;
      case types.LOGOUT:
        ability.update([]);
        break;
      default:
        break;
    }
  });
};
